"use client";

import type { ButtonVariantProps } from "@homeinstead/ui/components/Button";
import type { ReactElement } from "react";
import type { ControllerRenderProps, FieldPath } from "react-hook-form";
import type {
  CareForValue,
  CarePlusInquiryFormData,
} from "./carePlusInquiry.schema";

import { track } from "@homeinstead/analytics";
import { EventName, scrollToTop } from "@homeinstead/shared";
import { Button } from "@homeinstead/ui/components/Button";

export function CarePlusRecipientButton({
  field,
  careRecipient,
  nextStepCallback,
  className,
  children,
  buttonVariant = "secondary",
}: {
  field: ControllerRenderProps<
    CarePlusInquiryFormData,
    FieldPath<CarePlusInquiryFormData>
  >;
  careRecipient: CareForValue;
  nextStepCallback: () => void;
  className: string;
  children: ReactElement | ReactElement[];
  buttonVariant?: ButtonVariantProps["variant"];
}) {
  const handleNextStep = () => {
    if (typeof window === "undefined") {
      return;
    }
    field.onChange(careRecipient);
    track(EventName.CARE_PLUS_INQUIRY_RECIPIENT_SELECT, {
      care_for: careRecipient,
    });
    scrollToTop();
    nextStepCallback();
  };

  return (
    <Button
      className={className}
      onClick={handleNextStep}
      type="button"
      variant={buttonVariant}
    >
      {children}
    </Button>
  );
}
